<template>
  <div class="py-2">
    <div class="flex">
      <div class="flex-1 p-2">
        <span class="text-gray-600 font-semibold text-sm">{{label}}</span>
        <span class="block">{{company.name}}</span>
      </div>
      <span v-if="!!company.logoUrl" class="h-16 p-1 mx-2 bg-white rounded">
        <img class="h-full" :src="company.logoUrl" alt="">
      </span>
    </div>
    <a
      v-if="!!company.websiteUrl"
      :href="company.websiteUrl"
      target="_blank"
      class="block mx-2 mt-2 text-xs text-blue-500 cursor-pointer hover:underline"
    >{{company.websiteUrl}}</a>
  </div>
</template>

<script>
export default {
  name: 'CompanyDataBox',

  props: {
    label: {
      type: String,
      required: true,
    },
    company: {
      type: Object,
      required: true,
    },
  },
};
</script>
